module.exports = __webpack_public_path__ + "img/ic_publicity_detail1_2.67ca0742.png";